import { Grid, Typography } from '@mui/material';

export const ServicioInactivo = () => {
    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} margin={2} textAlign={"start"} justifyContent={'center'}>
                <Typography
                    variant="body1"
                >
                    Seguirás recobiendo unicamente tus notificaciones via correo electrónico.            
                </Typography>
            </Grid>
        </Grid>
    )
}
